import "./Login.css";
import LoginSection from "../../Component/LoginSection/LoginSection";

const Login = () => {
     return <div>
         <LoginSection />
     </div>
}

export default Login